import React, { useEffect, useState } from "react";

// components
import EmptyComponent from "../../components/EmptyComponent";
import NavDashboard from "../../components/NavDashboard";
import { numberFormat } from "../../helper";
import "./index.css";

// apollo-client
import { GET_PRODUCT_SALE_OUT } from "../../apollo/dashboard/query";
import { useLazyQuery } from "@apollo/client";

// react-bootrap
import { Card, Spinner, Table } from "react-bootstrap";
import { BsBagCheck } from "react-icons/bs";
import AnimationLoading from "../../components/Animationloading";
import { useCallback } from "react";
import PaginationsV2 from "../../components/PaginationsV2";

export default function ReportProductSaleOut() {
  const [productsaleout, setProductSaleOut] = useState();
  const [productsaletotal, setProductSaletotal] = useState();

  // ============== > UseLazyQuery And UseMutaion <==============

  const [Loadproductsaleout, { data: getproductsaleout, loading }] =
    useLazyQuery(GET_PRODUCT_SALE_OUT, { fetchPolicy: "cache-and-network" });

  const rowsPerPage = 50;
  const [page, setPage] = useState(0);
  const pageAll =
    productsaletotal > 0 ? Math.ceil(productsaletotal / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  // ============== > useEffect <==============

  useEffect(() => {
    if (getproductsaleout)
      setProductSaleOut(getproductsaleout?.productSaleOut?.data);
    setProductSaletotal(getproductsaleout?.productSaleOut?.total);
  }, [getproductsaleout]);

  // ============== > fuctions <==============

  const fetchProductSaleOut = async () => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    await Loadproductsaleout({
      variables: {
        skip: page * rowsPerPage,
        limit: rowsPerPage,
        where: {
          shop: shopId,
        },
      },
    });
  };

  useEffect(() => {
    fetchProductSaleOut();
  }, [page]);

  return (
    <NavDashboard title={"ລາຍງານສິນຄ້າຂາຍບໍ່ອອກ"}>
       <div className="py-4">
       <h3>ຈຳນວນສິນຄ້າທັງໜົດ ({productsaletotal ?? 0}) ລາຍການ</h3>
       </div>
      <Card style={{ padding: "2em" }}>
        {loading ? (
          <AnimationLoading />
        ) : (
          <>
            {productsaleout?.length > 0 ? (
              <Card.Body>
                <Table striped hover>
                  <thead
                    style={{
                      background: "#1F3A60",
                      color: "white",
                      fontWeight: "400",
                    }}>
                    <tr>
                      <th>ລຳດັບ</th>
                      <th>ຊື່ສິນຄ້າ</th>
                      <th>ປະເພດສິນຄ້າ</th>
                      <th>ເເບຣນສິນຄ້າ</th>
                      <th>ຈຳນວນ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productsaleout?.map((e, index) => (
                      <tr>
                        <td>{page * rowsPerPage + index + 1}</td>
                        <td>{e?.name}</td>
                        <td>{e?.category?.name}</td>
                        <td>{e?.brand?.name}</td>
                        <td>{numberFormat(e?.amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <PaginationsV2
                  count={productsaletotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  pageAll={pageAll}
                  onPageChange={handleChangePage}
                />
              </Card.Body>
            ) : (
              <div
                style={{
                  fontSize: "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#6B7280",
                  fontWeight: "400",
                }}>
                <EmptyComponent />
                <p>ຍັງບໍ່ທັນມີສິນຄ້າຂາຍບໍ່ອອກເທື່ອ !!!</p>
              </div>
            )}
          </>
        )}
      </Card>
    </NavDashboard>
  );
}
